import React from 'react';
import { Box, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import { ADD_PROGRAM } from 'constants/routes';
import withBreadcrumbs from 'hocs/withBreadcrumbs';
import ProgramsTable from './table';
import useStyles from '../style';

const Programs: React.FC<{}> = () => {
  const classes = useStyles();

  return (
    <div>
      <Box className={classes.topContent}>
        <Link to={ADD_PROGRAM}>
          <Button className={classes.addButton}>
            <Typography variant='h6'>Add New</Typography>
            <AddIcon />
          </Button>
        </Link>
      </Box>
      <Typography variant='subtitle1' className={classes.subtitleTop}>
        No Subscription Required
      </Typography>
      <ProgramsTable isRequired={false} />
      <Typography variant='subtitle1' className={classes.subtitleBottom}>
        Subscription Required
      </Typography>
      <ProgramsTable isRequired />
    </div>
  );
};

export default withBreadcrumbs(Programs);
